import { render, staticRenderFns } from "./StockListProductDepartments.vue?vue&type=template&id=016f35d6"
import script from "./StockListProductDepartments.vue?vue&type=script&lang=js"
export * from "./StockListProductDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports